import React, { useState, useEffect } from 'react';

// Dynamischer Hintergrund, der den gesamten main-Bereich einnimmt und periodisch den angezeigten Code ändert
const DynamicBackground = () => {
    // Verschiedene Code-Snippets, die angezeigt werden sollen
    const codeSnippets = [
        `// Wir basteln fleißig an neuen Features...
function innovate() {
  const ideas = ["Serverless", "Keycloak", "Redis"];
  ideas.forEach(idea => console.log("Building", idea));
}
innovate();
// Bleib dran – Großes kommt!`,
        `// Neue Features in Arbeit...
function deploy() {
  console.log("Deploying new features!");
}
deploy();`,
        `// Verbesserungen und Bugfixes...
let bugs = [];
bugs.push("Fixed bug #123");
console.log("All bugs fixed!");
`,
        `// Unser Code wird immer besser...
const optimize = () => console.log("Optimizing code!");
optimize();`
    ];

    // State für den aktuell angezeigten Index
    const [currentIndex, setCurrentIndex] = useState(0);

    // Alle 10 Sekunden das Code-Snippet wechseln
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % codeSnippets.length);
        }, 10000); // 10000ms = 10 Sekunden
        return () => clearInterval(interval);
    }, [codeSnippets.length]);

    return (
        <div className="absolute inset-0 z-0 overflow-hidden">
            {/* Mit key wird das Element bei Indexwechsel neu gerendert und die Animation startet erneut */}
            <pre key={currentIndex} className="typing-animation text-green-500 opacity-30 font-mono text-xs md:text-sm whitespace-pre-wrap">
                {codeSnippets[currentIndex]}
            </pre>
        </div>
    );
};

export default DynamicBackground;